import { DocsLayout } from '@/components/DocsLayout'
import { APP_URL, SITE_NAME } from '@/lib/config'
import { useHead } from '@/lib/head'
import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  useHead({
    title: `Page not found — ${SITE_NAME}`,
    description: 'That help page could not be found.',
    noIndex: true,
  })

  return (
    <DocsLayout>
      <div className="page not-found">
        <div className="not-found-code">404</div>
        <h1>We couldn't find that page</h1>
        <p>
          It may have been renamed, archived, or moved to a different category.
          Some articles are only available inside Scrambl — if you followed a
          link from the app,{' '}
          <a href={`${APP_URL}/help`}>open the in-app Help Center</a>. Otherwise
          try searching, or start from the <Link to="/">Help Center home</Link>.
        </p>
      </div>
    </DocsLayout>
  )
}
